import { render, staticRenderFns } from "./news-entry.component.vue?vue&type=template&id=991d2a7c&scoped=true&"
import script from "./news-entry.component.vue?vue&type=script&lang=js&"
export * from "./news-entry.component.vue?vue&type=script&lang=js&"
import style0 from "./news-entry.component.vue?vue&type=style&index=0&id=991d2a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991d2a7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
